import { Theme, ThemeMode } from '@/types';

export const THEMES: Theme[] = [
  {
    id: 'mst-mint',
    name: 'MST Mint',
    colors: {
      background: '220 20% 97%',
      foreground: '224 71.4% 4.1%',
      primary: '278 63% 45%',
      secondary: '220 14.3% 95.9%',
      accent: '43 100% 50%',
      muted: '220 14.3% 95.9%',
      border: '220 13% 90%',
      destructive: '31 99% 54%',
    },
  },
  {
    id: 'light',
    name: 'Light',
    colors: {
      background: '0 0% 100%',
      foreground: '224 71.4% 4.1%',
      primary: '262.1 83.3% 57.8%',
      secondary: '220 14.3% 95.9%',
      accent: '220 14.3% 95.9%',
      muted: '220 14.3% 95.9%',
      border: '220 13% 90%',
      destructive: '0 84.2% 60.2%',
    },
  },
  {
    id: 'dark',
    name: 'Dark',
    colors: {
      background: '224 71.4% 4.1%',
      foreground: '210 20% 98%',
      primary: '263.4 70% 50.4%',
      secondary: '215 27.9% 12.9%',
      accent: '215 27.9% 12.9%',
      muted: '215 27.9% 12.9%',
      border: '215 27.9% 12.9%',
      destructive: '0 62.8% 30.6%',
    },
  },
  {
    id: 'corporate',
    name: 'Corporate Blue',
    colors: {
      background: '210 100% 98%',
      foreground: '210 100% 15%',
      primary: '221.2 83.2% 53.3%',
      secondary: '210 60% 90%',
      accent: '210 80% 85%',
      muted: '210 60% 95%',
      border: '214.3 31.8% 90%',
      destructive: '0 75% 55%',
    },
  },
  {
    id: 'playful',
    name: 'Playful Purple',
    colors: {
      background: '300 100% 98%',
      foreground: '300 100% 15%',
      primary: '322.2 81.1% 55.7%',
      secondary: '320 60% 90%',
      accent: '290 80% 85%',
      muted: '310 60% 95%',
      border: '320 20% 89%',
      destructive: '350 75% 55%',
    },
  },
];

export const DEFAULT_THEME_MODE: ThemeMode = 'light';
export const DEFAULT_THEME: Theme = (THEMES[1] || THEMES[0]) as Theme;

export const THEME_STORAGE_KEY = 'admin-template-theme';
export const THEME_MODE_STORAGE_KEY = 'admin-template-theme-mode';

export function getSystemTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(theme: Theme, mode: ThemeMode) {
  const root = document.documentElement;
  const isDarkMode = mode === 'dark' || (mode === 'system' && getSystemTheme() === 'dark');

  // Remove all theme classes
  root.className = root.className
    .split(' ')
    .filter((c) => !c.startsWith('theme-'))
    .join(' ');

  // Add dark class if needed
  root.classList.toggle('dark', isDarkMode);

  // Add theme class
  root.classList.add(`theme-${theme.id}`);

  // Remove inline styles to allow CSS variables from CSS file to apply
  root.removeAttribute('style');
}

export function saveThemePreference(theme: Theme, mode: ThemeMode) {
  if (typeof window === 'undefined') return;

  localStorage.setItem(THEME_STORAGE_KEY, theme.id);
  localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
}

export function getStoredThemePreference(): { theme: Theme; mode: ThemeMode } {
  const theme = DEFAULT_THEME;
  const mode = DEFAULT_THEME_MODE;
  return { theme, mode };
}
